import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// 抑制 ResizeObserver 循环警告（klinecharts 等图表库常见，不影响功能）
const _onError = window.onerror
window.onerror = function (msg, url, line, col, err) {
  if (typeof msg === 'string' && msg.includes('ResizeObserver')) {
    return true
  }
  if (err && err.message && err.message.includes('ResizeObserver')) {
    return true
  }
  if (_onError) return _onError.apply(this, arguments)
  return false
}

// 捕获未处理的 Promise 拒绝中的 ResizeObserver 错误
window.addEventListener('unhandledrejection', function (e) {
  if (e.reason && e.reason.message && e.reason.message.includes('ResizeObserver')) {
    e.preventDefault()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
